var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "meeting" } },
    [
      _c("b-embed", {
        attrs: {
          type: "iframe",
          aspect: "16by9",
          src: _vm.asset.webrtc_url,
          allow: "camera; microphone; fullscreen; speaker; display-capture;",
          allowfullscreen: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }